export default "/images/c10403feed7a5fe03eafdf811e3ae717.avif";